import { useMemo } from 'react';
import { useToken } from '@chakra-ui/react';
import type { CustomIconProps } from '../types';

const ShoppingTag = ({
    width,
    height,
    color = 'currentColor',
    dataTestId,
    ...props
}: CustomIconProps): JSX.Element => {
    const [tokenColor] = useToken('colors', [color], [color]);
    const resolvedColor = useMemo(() => tokenColor, [tokenColor]);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? '16'}
            height={height ?? '16'}
            viewBox="0 0 16 16"
            fill="none"
            data-testid={dataTestId}
            {...props}
        >
            <path
                d="M14.4082 0.192383C15.1704 0.216969 15.783 0.829621 15.8076 1.5918L15.999 7.53613C16.0118 7.93555 15.8588 8.32289 15.5762 8.60547L8.60547 15.5762C8.04066 16.141 7.12438 16.141 6.55957 15.5762L0.423828 9.44043C-0.140981 8.87562 -0.140981 7.95934 0.423828 7.39453L7.39453 0.423828C7.67711 0.141245 8.06445 -0.0117976 8.46387 0.000976562L14.4082 0.192383ZM1.44629 8.41797L7.58203 14.5537L14.5537 7.58203L14.3623 1.6377L8.41797 1.44629L1.44629 8.41797Z"
                fill={resolvedColor}
            />
            <ellipse
                cx="11.8467"
                cy="4.19067"
                rx="0.78"
                ry="0.78"
                transform="rotate(45 11.8467 4.19067)"
                stroke={resolvedColor}
            />
        </svg>
    );
};

export default ShoppingTag;
